webpackJsonp([35783957827783],{

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _overviewModule = __webpack_require__(350);
	
	var _overviewModule2 = _interopRequireDefault(_overviewModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        alignItems: 'center',
	        display: 'flex',
	        flexDirection: 'column'
	      }
	    },
	    _react2.default.createElement(
	      'ul',
	      {
	        style: {
	          display: 'flexbox',
	          listStyle: 'none',
	          margin: 0,
	          padding: 0
	        }
	      },
	      _react2.default.createElement(
	        'li',
	        { className: _overviewModule2.default.listItem },
	        'consulting'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _overviewModule2.default.listItem },
	        'development'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _overviewModule2.default.listItem },
	        'design'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _overviewModule2.default.listItem },
	        'hosting'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"listItem":"src-components-overview----overview-module---listItem---2xYCU"};

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _overview = __webpack_require__(252);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          alignItems: 'center',
	          display: 'flex',
	          flexDirection: 'column',
	          height: '100%',
	          justifyContent: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'gigantoid'
	      ),
	      _react2.default.createElement(_overview2.default, null),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          style: {
	            background: 'transparent',
	            border: '1px solid',
	            color: '#546e7a',
	            cursor: 'pointer',
	            margin: '6em 0 0',
	            outline: 'none',
	            padding: '0.25em 1.5em 0.33em',
	            textDecoration: 'none'
	          },
	          to: '/contact/'
	        },
	        'contact'
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-c33dd9ee88379a6574af.js